import {useAuth} from "../providers/AuthProvider";
import {useCallback, useState} from "react";
import api from "../api";
import OtpModal from "../components/OtpModal";
import ForcedModal from "../components/ForcedModal";
import {Alert, Button, Form, FormGroup, Input, Label, ModalBody, ModalHeader} from "reactstrap";
import {ValidatorProvider} from "react-admin-base";
import {Validator} from "react-admin-base-bootstrap";
import {FormattedMessage} from "react-intl";

export default function ForgotPassword() {
    const [,login] = useAuth();
    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState();
    const [ username, setUsername ] = useState();
    const [ password, setPassword ] = useState();
    const [ password2, setPassword2 ] = useState();
    const [ url, setUrl ] = useState();
    const [ finalUrl, setFinalUrl ] = useState();

    const submitFirst = useCallback(async function(e) {
        e.preventDefault();

        setError(null);
        setLoading(true);
        try {
            const url = await api('/portal/reset', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify({
                    email: username
                })
            });
            setUrl(url);
        } catch(e) {
            setError(e);
        } finally {
            setLoading(false);
        }
    }, [setLoading, setUrl, username, setError]);

    const registerFinal = useCallback(async function (e) {
        e.preventDefault();

        setError(null);
        setLoading(false);
        try {
            await api(finalUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify({
                    email: username,
                    password: password
                })
            });
            await login(username, password);
        } catch(e) {
            setError(e);
        } finally {
            setLoading(false);
        }
    }, [ finalUrl, username, password, login, setLoading, setError ]);

    if (url && !finalUrl) {
        return <OtpModal
            url={url}
            email={username}
            onValidated={setFinalUrl}
        />;
    }

    return <ForcedModal>
        <ModalHeader>
            <FormattedMessage id="FORGOT_PASSWORD" />
        </ModalHeader>
        <ModalBody>
            <ValidatorProvider>
                <Form onSubmit={finalUrl ? registerFinal : submitFirst}>
                    <FormGroup>
                        <Label><FormattedMessage id="EMAIL_ADDRESS" /></Label>
                        <Validator name="email" type="required|email">
                            <Input
                                type="email"
                                value={username || ''}
                                onChange={a => setUsername(a.currentTarget.value)}
                                disabled={!!loading}
                            />
                        </Validator>
                    </FormGroup>
                    {
                        finalUrl && <>
                            <FormGroup>
                                <Label><FormattedMessage id="PASSWORD" /></Label>
                                <Validator name="password" type="required">
                                    <Input
                                        type="text"
                                        value={password || ''}
                                        onChange={a => setPassword(a.currentTarget.value)}
                                        disabled={!!loading}
                                    />
                                </Validator>
                            </FormGroup>
                            <FormGroup>
                                <Label><FormattedMessage id="PASSWORD_AGAIN" /></Label>
                                <Validator name="password2" type={["required", { in: password }]}>
                                    <Input
                                        type="text"
                                        value={password2 || ''}
                                        onChange={a => setPassword2(a.currentTarget.value)}
                                        disabled={!!loading}
                                    />
                                </Validator>
                            </FormGroup>
                        </>
                    }
                    { error && <Alert color="danger" size="sm" toggle={a => setError(null)}>
                        { error.message }
                    </Alert> }
                    <Button type="submit" block color="primary" disabled={!!loading}>
                        <FormattedMessage id={ !finalUrl ? 'SEND_VERIFICATION' : 'RESET_PASSWORD' } />
                    </Button>
                </Form>
            </ValidatorProvider>
        </ModalBody>
    </ForcedModal>;
}
